<template>
<div id="mypage">
    <div id="policy-content">
        <div class="btn-close" @click="close_layer">
            <span class="bar"></span>
            <span class="bar"></span>
        </div>
        <!-- <iframe src="http://devgroup.co.kr/privacy/policy.php" frameborder="0"></iframe> -->
        <iframe src="https://readingroom.momu24.com/apps/solution_app_policy.php" frameborder="0"></iframe>
    </div>
    <div id="main">
        <template v-if="login_chk">
            <div id="mypage_wrap">
                <div class="mypage-content">

                    <div class="profile">
                        <div class="profile-name">
                            <img src="../../assets/images/user.png" alt="user-icon"><span>{{user_name}}</span>
                        </div>
                        <div class="profile-number">{{user_phone}}</div>
                        <div class="btn-mypage">
                            <div class="btn-info-change" @click="edit_info"><span>내 정보 변경</span></div>
                            <div class="btn-info-change btn-logout" @click="logout()"><span>로그아웃</span></div>
                        </div>
                    </div>
                    <div class="mycafe-list-wrap">
                        <div class="mycafe-list">
                            <h2>내 카페 목록</h2>
                            <ul>
                                <li :key="index" v-for="(item, index) in store_list">
                                    <!-- <div class="mycafe-img" :style="background: 'url('+host_url+'/'+store.photograph_path+') no-repeat center center/cover"></div> -->
                                    <div class="mycafe-img" :style="{background: 'url('+host_url+'/'+item.photograph_path+') no-repeat center center/cover' }"></div>
                                    <div class="mycafe">
                                        <div class="mycafe-name">{{item.store_name}}</div>
                                        <div class="mycafe-address">{{item.address}}</div>
                                        <div class="mycafe-address">{{item.address_detail}}</div>
                                    </div>
                                    <div class="btn-shortcut" @click="goKioskMobile(item.store_id, item.user_id, item.store_name)"><span v-if="item.app_open > 1">바로가기 →</span></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div class="adv-wrap">
                        <img src="../../assets/images/adv.png" class="adv"/>
                    </div> -->
                    <div class="cs-info-wrap">
                        <div class="cs-info">고객센터 정보</div>
                        <div class="cs-menu">
                            <ul>
                                <li><span>이용약관</span></li>
                                <li class="policy"><span @click="open_layer">개인정보 취급방침</span></li>
                                <li><span>위치기반정보 이용약관</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div id="mypage_wrap">
                <div class="mypage-content">
                    <div class="nouser-wrap">
                        <div class="nouser">
                            <span>로그인이 필요한 서비스입니다.</span>
                            <div class="btn-gologin" @click="go_login()">
                                <span>로그인 및 회원가입</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="adv-wrap">
                        <img src="../../assets/images/adv.png" class="adv"/>
                    </div> -->
                    <div class="cs-info-wrap">
                        <div class="cs-info">고객센터 정보</div>
                        <div class="cs-menu">
                            <ul>
                                <li><span>이용약관</span></li>
                                <li class="policy"><span @click="open_layer">개인정보 취급방침</span></li>
                                <li><span>위치기반정보 이용약관</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
export default {
    name: 'mypage',
    components: {},
    data() {
        return {
            login_chk: false,
            user_name: '',
            user_phone: '',
            store_list: [],
            host_url: ''

        }
    },
    mounted() {
        this.$nextTick(function () {
            this.login_chk = this.$store.getters['getLogin_chk'].value;
            if (this.login_chk) {
                this.host_url = config.HOST;
                var user_info = this.$store.getters['getUser_info'];
                this.user_name = user_info.value.name;
                this.user_phone = user_info.value.user_hp;

                var data = {
                    m_user_id: user_info.value.m_user_id,
                }
                var type = config.REQ_USER_JOIN_STORE_LIST;
                common.getData(type, data,
                    (response) => {
                        this.store_list = response;
                        for (let i = 0; i < this.store_list.length; i++) {
                            if (this.store_list[i].photograph_path == null) {
                                this.store_list[i].photograph_path = '/images/MOBILE/defalut.jpg'
                            }
                        }
                    })
            }

        });

    },
    methods: {
        go_login() {
            this.$router.push('/login');
        },
        logout() {
            this.$router.push('/');
            var data = {
                m_user_id: '',
                name: '',
                user_hp: '',
                parents_hp: '',
                memo: '',
                agree_yn: '',
                join_datetime: '',
                age: '',
                sex: ''
            }

            this.$store.commit('setUser_info', {
                value: data
            });
            this.$store.commit('setLogin_chk', {
                value: false
            });

            common.removeAutoLoginSetting();
        },
        goKioskMobile(store_id, user_id, store_name){
            var data = {};
            data.store_id = store_id;
            data.user_id = user_id;
            data.store_name = store_name;
            var params = JSON.stringify(data);
            common.goKioskMobile(params);
        },
        edit_info() {
            this.$router.push('/edit_info');

        },
        open_layer() {
            document.getElementById('policy-content').classList.add('on');
        },
        close_layer() {
            document.getElementById('policy-content').classList.remove('on');
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/MyPage.vue